import { useState } from 'react';
import { CertificateSlot } from '@/components/certificates/CertificateSlot';
import { DangerZone } from '@/components/settings/DangerZone';
import { NotificationMatrix } from '@/components/settings/NotificationMatrix';
import { ProfileForm } from '@/components/settings/ProfileForm';
import { SubscriptionCard } from '@/components/settings/SubscriptionCard';
import { ThemePicker } from '@/components/settings/ThemePicker';
import { ToleranceSlider } from '@/components/settings/ToleranceSlider';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useCnpjs } from '@/features/cnpjs/hooks';

export default function SettingsPage() {
  const [tab, setTab] = useState('profile');
  const cnpjsQuery = useCnpjs();

  return (
    <div className="flex flex-col gap-4">
      <header>
        <h1 className="font-display text-2xl font-semibold">Configurações</h1>
        <p className="text-sm text-(--color-fg-muted)">
          Perfil, CNPJs, certificados e preferências.
        </p>
      </header>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex-wrap">
          <TabsTrigger value="profile">Perfil</TabsTrigger>
          <TabsTrigger value="cnpjs">CNPJs &amp; Certificados</TabsTrigger>
          <TabsTrigger value="theme">Tema</TabsTrigger>
          <TabsTrigger value="notifications">Notificações</TabsTrigger>
          <TabsTrigger value="tolerance">Tolerância</TabsTrigger>
          <TabsTrigger value="subscription">Assinatura</TabsTrigger>
          <TabsTrigger value="privacy">Privacidade</TabsTrigger>
        </TabsList>

        <TabsContent value="profile">
          <ProfileForm />
        </TabsContent>

        <TabsContent value="cnpjs">
          {cnpjsQuery.isLoading ? (
            <p className="text-sm text-(--color-fg-muted)">Carregando CNPJs…</p>
          ) : cnpjsQuery.data && cnpjsQuery.data.length > 0 ? (
            <div className="flex flex-col gap-3">
              {cnpjsQuery.data.map((c) => (
                <CertificateSlot
                  key={c.id}
                  cnpjId={c.id}
                  cnpjLabel={c.tradeName ?? c.legalName}
                />
              ))}
            </div>
          ) : (
            <Card>
              <CardHeader>
                <CardTitle>Nenhum CNPJ cadastrado</CardTitle>
              </CardHeader>
              <p className="text-sm text-(--color-fg-muted)">
                Cadastre um CNPJ no onboarding para poder enviar o certificado A1.
              </p>
            </Card>
          )}
        </TabsContent>

        <TabsContent value="theme">
          <ThemePicker />
        </TabsContent>

        <TabsContent value="notifications">
          <NotificationMatrix />
        </TabsContent>

        <TabsContent value="tolerance">
          <ToleranceSlider />
        </TabsContent>

        <TabsContent value="subscription">
          <SubscriptionCard />
        </TabsContent>

        <TabsContent value="privacy">
          <DangerZone />
        </TabsContent>
      </Tabs>
    </div>
  );
}
